<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        append-icon="mdi-calendar"
        :readonly="readonly"
        v-maska:[options]
        v-model="formattedDate"
        @click:clear="clear"
        v-bind="$attrs"
        @click:append="showPicker = true"
        :error-messages="validateDate"
        :placeholder="format"
        @blur="textChange"
        @keydown.enter="handleEnter"
      ></v-text-field>
    </template>
    <v-date-picker
      :disabled="readonly"
      v-model="dateValue"
      @change="change"
      @input="showPicker = false"
      :locale="userCultureCode"
      :first-day-of-week="1"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import Utils from '@/ecm/common/Utils';
export default {
    props: {
        value: {
            type: String
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: Array,
            default: () => [],
        },
    },
    created() {
        this.dateValue = null;
        if (this.value && Utils.date.IsValidDate(this.value, 'yyyy-MM-dd')) {
            this.dateValue = this.value;
            this.formattedDate = Utils.date.changeFormat(this.dateValue, 'yyyy-MM-dd', this.metricDateFormat);
        }
    },
    data() {
        return {
            showPicker: false,
            userCultureCode: this.$store.getters['account/user'].CultureCode,
            dateValue: this.value || null,
            format: '',
            metricDateFormat: this.$store.getters['account/user'].MetricDateFormat,
            inputText: '',
            options: {
                mask: '',
            },
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        },
        validateDate() {
            const errors = [];
            if (this.inputText) {
                if (!Utils.date.IsValidDate(this.inputText, this.metricDateFormat)) {
                    errors.push(this.$t('InvalidDate'));
                }
            }
            if (this.errorMessages && errors.length === 0) {
                errors.push(...this.errorMessages);
            }
            return errors;
        },
        formattedDate: {
            get() {
                if (this.dateValue) {
                    return Utils.date.changeFormat(this.dateValue, 'yyyy-MM-dd', this.metricDateFormat);
                }

                return null;
            },
            set(newValue) {
                this.inputText = newValue;
            },
        }
    },
    mounted() {
        this.format = this.userMask();
        this.options.mask = this.userMask();
    },
    methods: {
        handleEnter() {
            this.textChange();
            this.showPicker = false;
        },
        userMask() {
            return this.$store.getters['account/user'].MetricDateFormat.replaceAll('Y', '#')
                .replaceAll('y', '#')
                .replaceAll('M', '#')
                .replaceAll('m', '#')
                .replaceAll('D', '#')
                .replaceAll('d', '#');
        },
        clear() {
            this.dateValue = null;
            this.change();
        },
        change() {
            this.inputText = Utils.date.changeFormat(this.dateValue, 'yyyy-MM-dd', this.metricDateFormat);
            this.$emit('input', this.dateValue);
            this.$emit('change', this.dateValue);

        },
        textChange() {
            if (this.inputText) {
                if (Utils.date.IsValidDate(this.inputText, this.metricDateFormat)) {
                    this.dateValue = Utils.date.changeFormat(this.inputText, this.metricDateFormat, 'yyyy-MM-dd');
                    this.$emit('input', this.dateValue);
                    this.$emit('change', this.dateValue);
                } else {
                    this.dateValue = null;
                    this.$emit('input', this.dateValue);
                    this.$emit('change', this.dateValue);
                }
            }
        },
    },
};
</script>